/**
 * Workspace / process access helpers.
 *
 * Investor is a workspace (organization type) of its own: a platform-wide,
 * read-only view. Read-only therefore follows the workspace role, never a
 * membership role inside another organisation.
 */

const READ_ONLY_ROLES = new Set(['investor']);

export function isReadOnlyRole(role) {
  return READ_ONLY_ROLES.has(String(role || '').trim().toLowerCase());
}

/** True when the signed-in session may only read (Investor workspace). */
export function isReadOnlySession(session) {
  if (!session) return false;
  return isReadOnlyRole(session.role) || isReadOnlyRole(session.workspaceId);
}

/** True when the actor may start certify / admit / pledge / Digitize VA / etc. */
export function canRunProcesses(role) {
  return !isReadOnlyRole(role);
}

/** Session-aware variant of canRunProcesses. */
export function sessionCanRunProcesses(session) {
  return !isReadOnlySession(session);
}
